export function calculateNetSellerFromApplication(
  application: { offerAmount?: number | null | undefined },
  estate: {
    mandate: {
      fixedFee: number
      proportionalFeesRate: number
      feeVATRate: number
      fixedFeeThreshold: number
    }
  }
) {
  return calculateNetSeller(
    application.offerAmount ?? 0,
    estate.mandate.fixedFee,
    estate.mandate.proportionalFeesRate,
    estate.mandate.feeVATRate,
    estate.mandate.fixedFeeThreshold
  )
}

export function calculateNetSeller(
  offerAmount: number,
  fixedFee: number,
  proportionalFeesRate: number,
  feeVATRate: number,
  fixedFeeThreshold: number
) {
  const fees =
    offerAmount <= fixedFeeThreshold
      ? fixedFee
      : (proportionalFeesRate / 100) * offerAmount

  const feesPlusTaxes = fees * (1 + feeVATRate / 100)

  return offerAmount - feesPlusTaxes
}
